module.exports = {"360721100":"梅林镇","360721101":"王母渡镇","360721102":"沙地镇","360721103":"江口镇","360721104":"田村镇","360721105":"南塘镇","360721106":"茅店镇","360721107":"吉埠镇","360721108":"五云镇","360721109":"湖江镇","360721110":"储潭镇","360721111":"韩坊镇","360721201":"阳埠乡","360721202":"大埠乡","360721203":"长洛乡","360721204":"大田乡","360721207":"石芫乡","360721208":"三溪乡","360721209":"白鹭乡","360721400":"江西赣县经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360721.json
// module id = 1401
// module chunks = 0